var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _circle3, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSingleAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#38BED3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.9144,
    cy: 12.9222,
    r: 3.52374,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7188 18.6475H22.123V17.6572C25.1821 18.5986 27.4051 21.4476 27.4053 24.8154V25.915C27.4053 26.6229 26.929 27.241 26.2393 27.4004C24.6579 27.7658 21.7925 28.3513 19.71 28.3389C17.7619 28.3272 15.0918 27.7644 13.5859 27.4062C12.9006 27.2433 12.4298 26.6273 12.4297 25.9229V24.8154C12.4298 21.4453 14.6565 18.5956 17.7188 17.6562V18.6475Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1562 24.9126L19.0959 20.4062H20.7403L21.68 25.1498L20.0356 26.5728L18.1562 24.9126Z",
    fill: "white",
    stroke: "#38BED3",
    strokeWidth: 0.858065,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1562 19.0938L18.9113 20.8556H20.9249L21.68 19.0938H18.1562Z",
    fill: "white",
    stroke: "#38BED3",
    strokeWidth: 0.858065,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.711 20.8504L16.4219 18.6976L18.5919 17.5469L19.9133 19.0885L17.711 20.8504Z",
    fill: "white",
    stroke: "#38BED3",
    strokeWidth: 0.858065,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1183 20.8504L23.3281 18.6497L21.2374 17.5469L19.916 19.0885L22.1183 20.8504Z",
    fill: "white",
    stroke: "#38BED3",
    strokeWidth: 0.858065,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.0908,
    cy: 26.8799,
    r: 6.20086,
    fill: "white",
    stroke: "#38BED3",
    strokeWidth: 0.858065
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6562 26.8818C24.6562 26.5026 24.9636 26.1953 25.3427 26.1953H30.8343C31.2134 26.1953 31.5208 26.5026 31.5208 26.8818C31.5208 27.2609 31.2134 27.5682 30.8343 27.5682H25.3427C24.9636 27.5682 24.6562 27.2609 24.6562 26.8818Z",
    fill: "#38BED3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0927 30.3125C27.7136 30.3125 27.4062 30.0052 27.4062 29.626V24.1344C27.4062 23.7553 27.7136 23.448 28.0927 23.448C28.4718 23.448 28.7792 23.7553 28.7792 24.1344V29.626C28.7792 30.0052 28.4718 30.3125 28.0927 30.3125Z",
    fill: "#38BED3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleAdd);
export default __webpack_public_path__ + "static/media/singleAdd.dbd6b2d34be57d7df36d88a04169ba14.svg";
export { ForwardRef as ReactComponent };